import { render, staticRenderFns } from "./businessDataOverview.vue?vue&type=template&id=efbbae60&scoped=true"
import script from "./businessDataOverview.vue?vue&type=script&lang=js"
export * from "./businessDataOverview.vue?vue&type=script&lang=js"
import style0 from "./businessDataOverview.vue?vue&type=style&index=0&id=efbbae60&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efbbae60",
  null
  
)

export default component.exports